import React from "react";
import PropTypes from "prop-types";
import { FormRow } from "./FormRow";
import { FormSelectField } from "@arcteryx/components-form";

export const SelectInput = ({
  placeHolder,
  options,
  id,
  label,
  register,
  requiredMsg,
  required,
  validInputs,
  setValidInputs,
  errors
}) => {
  const list = options.map(item => ({
    value: item.en,
    label: item[language]
  }));

  const validCategoryProps = {
    list,
    placeHolderText: placeHolder[language],
    disallowEmptyOption: false
  };

  let formValidation = { ...register(id) };

  if (requiredMsg) {
    formValidation = {
      ...register(id, {
        required: requiredMsg[language],
        validate: {
          validInput: value =>
            value.length > 0
              ? setValidInputs(prev => ({
                  ...prev,
                  id: true
                }))
              : setValidInputs(prev => ({
                  ...prev,
                  id: false
                }))
        }
      })
    };
  }

  return (
    <FormRow>
      <FormSelectField
        {...validCategoryProps}
        id={id}
        name={id}
        type="select"
        label={label}
        required={required}
        valid={validInputs.id}
        error={errors[id]}
        {...formValidation}
      />
    </FormRow>
  );
};

SelectInput.defaultProps = {
  requiredMsg: null
};

SelectInput.propTypes = {
  placeHolder: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  validInputs: PropTypes.object.isRequired,
  setValidInputs: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  requiredMsg: PropTypes.object
};

export default SelectInput;
